import { DropdownMenu, DropdownMenuItem } from '@tryhackme/thm-ui-components';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import { downloadSpreadsheet } from 'src/common/xlsx';
import { StyledButton, StyledDownloadIcon } from '../../user-occupation.styles';
import { UserOccupationItem } from '../../user-occupation.types';
import { StyledCustomMenuItemContent } from './user-occupation.styles';
export const UserOccupationDownload = ({
  occupationData
}: {
  occupationData: UserOccupationItem[];
}) => {
  const csv = () => {
    downloadSpreadsheet(occupationData, 'occupationData', 'csv');
  };
  const excel = () => {
    downloadSpreadsheet(occupationData, 'occupationData', 'xlsx');
  };
  return <DropdownMenu sideOffset={10} type="button" isAnimated triggerBtn={<StyledButton variant="outlined" color="secondary">
          <StyledDownloadIcon icon={faDownload} />
          Download
        </StyledButton>} data-sentry-element="DropdownMenu" data-sentry-component="UserOccupationDownload" data-sentry-source-file="user-occupation-download.tsx">
      <DropdownMenuItem onSelect={csv} data-sentry-element="DropdownMenuItem" data-sentry-source-file="user-occupation-download.tsx">
        <StyledCustomMenuItemContent data-sentry-element="StyledCustomMenuItemContent" data-sentry-source-file="user-occupation-download.tsx">Download CSV</StyledCustomMenuItemContent>
      </DropdownMenuItem>
      <DropdownMenuItem onSelect={excel} data-sentry-element="DropdownMenuItem" data-sentry-source-file="user-occupation-download.tsx">
        <StyledCustomMenuItemContent data-sentry-element="StyledCustomMenuItemContent" data-sentry-source-file="user-occupation-download.tsx">Download Excel</StyledCustomMenuItemContent>
      </DropdownMenuItem>
    </DropdownMenu>;
};